import * as stylex from '@stylexjs/stylex';
import clsx from 'clsx';
import Button from '../Button';
import { colors } from '../theme/colors.stylex';
import { controlMetrics } from '../theme/controls.stylex';
import type { EditorPanelProps } from './EditorPanel.types';

const styles = stylex.create({
  panel: {
    boxSizing: 'border-box',
    marginTop: '0.75rem',
    marginBottom: '0.25rem',
    display: 'flex',
    width: '100%',
    maxWidth: '28rem',
    flexDirection: 'column',
    alignItems: 'flex-start',
    borderRadius: '1.5rem',
    borderWidth: controlMetrics.borderWidth,
    borderStyle: 'solid',
    borderColor: colors.panelBorder,
    backgroundColor: colors.panelBackground,
    paddingLeft: '1rem',
    paddingRight: '1rem',
    paddingTop: '0.75rem',
    paddingBottom: '0.75rem',
    boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
  },
  normal: { gap: '0.5rem' },
  spacious: { gap: '0.75rem' },
  title: {
    fontSize: '0.75rem',
    lineHeight: '1rem',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.025em',
    color: colors.accent,
  },
  actions: {
    display: 'flex',
    width: '100%',
    maxWidth: '100%',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '0.5rem',
  },
});

const EditorPanel = ({
  title,
  children,
  onApply,
  onCancel,
  isApplyDisabled = false,
  applyLabel = 'Apply',
  cancelLabel = 'Cancel',
  spacing = 'normal',
  extraClassNames = '',
  xstyle,
  id,
  testId,
}: EditorPanelProps) => {
  const styleProps = stylex.props(styles.panel, styles[spacing], xstyle);
  return (
    <div {...styleProps} className={clsx(styleProps.className, extraClassNames)} data-testid={testId} id={id}>
      <span {...stylex.props(styles.title)}>{title}</span>
      {children}
      <div {...stylex.props(styles.actions)}>
        {onCancel && <Button label={cancelLabel} onClick={onCancel} size="sm" variant="outline" />}
        {onApply && (
          <Button disabled={isApplyDisabled} label={applyLabel} onClick={onApply} size="sm" variant="theme" />
        )}
      </div>
    </div>
  );
};

export default EditorPanel;
